import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const reload = () => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  useEffect(() => { reload(); }, []);
  return <SettingsCtx.Provider value={{ settings, reload }}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);
